import pluralize from "pluralize"

export const singularize = phrase => {
  return phrase
    .split(" ")
    .map(word => {
      return pluralize.isPlural(word) ? pluralize.singular(word) : word
    })
    .join(" ")
}
